import { Marker, MarkerDragEvent } from "react-map-gl/dist/maplibre"
import { useAppSelector } from "integrations/redux/hooks"
import { selectAdsbCircleCenter, selectAdsbIsPlacingCircle, setAdsbCircleCenter } from "../slice"
import useThrottledDispatch from "tools/store/useThrottledDispatch"

export const AdsbAreaHandle = () => {
    const { throttledDispatch } = useThrottledDispatch(16) // 60 fps
    const isPlacingCircle = useAppSelector(selectAdsbIsPlacingCircle)
    const center = useAppSelector(selectAdsbCircleCenter)

    if (!isPlacingCircle || !center) return null

    const handleDrag = (e: MarkerDragEvent) => {
        throttledDispatch(setAdsbCircleCenter({ lat: e.lngLat.lat, lng: e.lngLat.lng }))
    }

    return (
        <Marker
            longitude={center.lng}
            latitude={center.lat}
            draggable
            onDrag={handleDrag}
            style={{ cursor: "move" }}
        >
            <div className="w-5 h-5 rounded-full border-2 border-white shadow bg-blue-500" />
        </Marker>
    )
}
